export const INVOKE_HTTP = 'InteractionInterface.v1_0.InvokeHttpSkillMethod';
export const INVOKE_HTTP_GLOBAL = 'InteractionInterface.v1_0.GlobalInvokeHttpSkillMethod';
